export * from './useCompactWorkspaceSecondaryMenu.types';
export { default as useCompactWorkspaceSecondaryMenu } from './useCompactWorkspaceSecondaryMenu';
